import LockTableCellRenderer from "./LockTableCellRenderer";

export default class OtherTasksNameCellRenderer extends LockTableCellRenderer{
    generateContent(cell)
    {
        cell.getCellEl().innerHTML = "<div class='otherTasksNameCell'>" + cell.getValue() + "</div>";
    }

    getTopBorderClassName(cell)
    {
        let cssClass = "";
        if (cell.getRow().isFirstChildRow())
            cssClass = "detailsRowSeparator";
        else if (cell.getRow().hasRowSeparator())
            cssClass = "taskNameTopBorder";
        else
            cssClass = "notAvailableTaskTopBorder";
        return cssClass;
    }

    getComplicatedBorderClassName(cell)
    {
        let firstRow = cell.getRow().isFirstChildRow();
        let lastRow = cell.getRow().isLastChildRow();
        if (firstRow || lastRow)
            return (firstRow && lastRow) ? "singleDetailsRow" :
                   (firstRow ? "firstDetailsRow" : "lastDetailsRow");
        else
            return "";
    }

    getCellClassName(cell)
    {
        return "notAvailableTaskCell TaskCell";
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/OtherTasksNameCellRenderer.js